export const GET_SALESORDER_REQUEST = "GET_SALESORDER_REQUEST";
export const GET_SALESORDER_SUCCESS = "GET_SALESORDER_SUCCESS";
export const GET_SALESORDER_FAIL = "GET_SALESORDER_FAIL";

export const CREATE_SALESORDER_REQUEST = "CREATE_SALESORDER_REQUEST";
export const CREATE_SALESORDER_SUCCESS = "CREATE_SALESORDER_SUCCESS";
export const CREATE_SALESORDER_FAIL = "CREATE_SALESORDER_FAIL";

export const UPDATE_SALESORDER_REQUEST = "UPDATE_SALESORDER_REQUEST";
export const UPDATE_SALESORDER_SUCCESS = "UPDATE_SALESORDER_SUCCESS";
export const UPDATE_SALESORDER_FAIL = "UPDATE_SALESORDER_FAIL";

export const DELETE_SALESORDER_REQUEST = "DELETE_SALESORDER_REQUEST";
export const DELETE_SALESORDER_SUCCESS = "DELETE_SALESORDER_SUCCESS";
export const DELETE_SALESORDER_FAIL = "DELETE_SALESORDER_FAIL";

export const GET_CUSTOMERSALESORDER_REQUEST = "GET_CUSTOMERSALESORDER_REQUEST";
export const GET_CUSTOMERSALESORDER_SUCCESS = "GET_CUSTOMERSALESORDER_SUCCESS";
export const GET_CUSTOMERSALESORDER_FAIL = "GET_CUSTOMERSALESORDER_FAIL";

export const GENERATE_PDF_REQUEST = "GENERATE_PDF_REQUEST";
export const GENERATE_PDF_SUCCESS = "GENERATE_PDF_SUCCESS";
export const GENERATE_PDF_FAIL = "GENERATE_PDF_FAIL";

export const ADD_SELECTED_INVOICE = "ADD_SELECTED_INVOICE";
export const REMOVE_SELECTED_INVOICE = "REMOVE_SELECTED_INVOICE";
export const CLEAR_SELECTED_INVOICE = "CLEAR_SELECTED_INVOICE";

export const ADD_MULTI_SELECTED_INVOICE = "ADD_MULTI_SELECTED_INVOICE";
export const REMOVE_MULTI_SELECTED_INVOICE = "REMOVE_MULTI_SELECTED_INVOICE";
